<template >
<!-- Desktop -->
<div v-if="this.$store.getters.Loaded && this.$store.getters.GetMobile && this.$store.getters.GetBlock.navbar" uk-sticky="end: #transparent-sticky-navbar; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky">
<!-- Nav ok-->    
    <nav class="uk-navbar-container uk-position-z-index-one uk-position-fixed uk-width-1-1 uk-text-uppercase" uk-navbar>
        <div class="uk-navbar-center">
            <ul class="uk-navbar-nav ">                
                <li class="uk-active uk-link-heading uk-menu-item">
                    <router-link class="uk-link-heading uk-menu-item uk-text-emphasis" to="/">{{ this.$store.getters.GetText.navbar.general[this.$store.getters.Lang]}}</router-link>                     
                </li>
                <li v-if="this.$store.getters.GetBlock.navbar2">
                    <router-link href="#payment" uk-scroll class="uk-link-heading uk-menu-item uk-text-emphasis" to="/more">{{this.$store.getters.GetText.navbar.aditional[this.$store.getters.Lang]}}</router-link>
                </li>
                <li v-if=" this.$store.getters.GetAccess">                            
                    <router-link href="#" uk-scroll class="  uk-link-heading uk-menu-item uk-text-emphasis uk-text-primary" to="/publish">{{this.$store.getters.GetText.navbar.personal[this.$store.getters.Lang]}}</router-link> 
                </li>
                <li v-if="!this.$store.getters.GetAccess && this.$store.getters.GetBlock.registration">                           
                    <router-link href="#" uk-scroll class="  uk-link-heading uk-menu-item uk-text-emphasis uk-text-primary" to="/register">{{this.$store.getters.GetText.navbar.reg[this.$store.getters.Lang]}}</router-link> 
                </li>
                <li v-if="!this.$store.getters.GetAccess">                            
                    <router-link href="#" uk-scroll class="  uk-link-heading uk-menu-item uk-text-emphasis uk-text-primary" to="/login">{{this.$store.getters.GetText.navbar.login[this.$store.getters.Lang]}}</router-link> 
                </li>
                <li v-if="this.$store.getters.GetAccess">                       
                    <a class="  uk-link-heading uk-menu-item uk-text-emphasis uk-text-primary" uk-scroll v-on:click="logout">{{this.$store.getters.GetText.navbar.logout[this.$store.getters.Lang]}}</a>
                </li>
                <li v-if="this.$store.getters.GetBlock.multilang">
                    <a class="  uk-link-heading uk-menu-item uk-text-warning" uk-scroll v-on:click="this.$store.commit('CHANGE_Lang')">{{this.$store.getters.Lang}}</a>
                </li>
                <!--li>
                    <a v-if="this.$store.getters.GetRoot" class="  uk-link-heading uk-menu-item" v-on:click="this.$store.commit('CHANGE_Editor')" uk-icon="icon: pencil"></a>                    
                </li> 
                <li>
                    <a v-if="this.$store.getters.GetRoot" class="  uk-link-heading uk-menu-item" href="" uk-scroll="" uk-icon="icon: mail"></a>                    
                </li-->                 
            </ul>
        </div>
    </nav>
</div>
<!-- Mobile -->
<div v-if="this.$store.getters.Loaded && !this.$store.getters.GetMobile && this.$store.getters.GetBlock.navbar" class="uk-flex  uk-position-top-right uk-position-fixed uk-position-z-index">
    <div class="uk-container-small uk-container-right ">
        <nav class="uk-navbar uk-navbar-container uk-margin uk-navbar-transparent uk-position-z-index uk-text-uppercase" uk-navbar>
            <div class="uk-navbar-right ">
                <a class="uk-navbar-toggle uk-navbar-toggle-animate uk-margin-right uk-margin-top uk-icon-button uk-width" uk-navbar-toggle-icon href="#"></a>
                <div class="uk-navbar-dropdown uk-position-z-index-one uk-navbar-dropdown-width-2"  >
                    <ul class="uk-nav uk-navbar-dropdown-nav  ">
                        <hr class="uk-divider-small">
                        <hr class="uk-divider-small">
                        <li>                                 
                             <router-link class=" uk-menu-item uk-text-default" to="/">{{this.$store.getters.GetText.navbar.general[this.$store.getters.Lang]}}</router-link>
                        </li>                        
                        <hr class="uk-divider-small">
                        <li  v-if="this.$store.getters.GetBlock.navbar2">
                            <router-link href="#payment" class="  uk-menu-item uk-text-default" to="/more">{{this.$store.getters.GetText.navbar.aditional[this.$store.getters.Lang]}}</router-link>
                        </li>
                        <hr class="uk-divider-small">
                        <li v-if=" this.$store.getters.GetAccess">                            
                            <router-link href="#" uk-scroll class="  uk-link-heading uk-menu-item" to="/publish">{{this.$store.getters.GetText.navbar.personal[this.$store.getters.Lang]}}</router-link> 
                        </li>                                             
                        <li v-if="!this.$store.getters.GetAccess && this.$store.getters.GetBlock.registration">                          
                            <router-link href="#" uk-scroll class="  uk-menu-item uk-text-default" to="/register">{{this.$store.getters.GetText.navbar.reg[this.$store.getters.Lang]}}</router-link> 
                        </li>
                        <hr class="uk-divider-small">
                        <li v-if="!this.$store.getters.GetAccess">                           
                            <router-link href="#" uk-scroll class="  uk-menu-item uk-text-default" to="/login">{{this.$store.getters.GetText.navbar.login[this.$store.getters.Lang]}}</router-link> 
                        </li>
                        <li v-if="this.$store.getters.GetAccess">                       
                            <a class="  uk-link-heading uk-menu-item" uk-scroll v-on:click="logout">{{this.$store.getters.GetText.navbar.logout[this.$store.getters.Lang]}}</a>
                        </li>    
                        <hr class="uk-divider-small">                    
                        <!--li v-if="this.$store.getters.GetAccess">                            
                            <a class="  uk-link-heading uk-menu-item" uk-scroll v-on:click="this.$store.commit('CHANGE_Lang')">{{this.$store.getters.Lang}}</a>
                        </li-->
                        <!--hr class="uk-divider-small">
                        <li>
                            <a v-if="this.$store.getters.MultiLang" class=" uk-menu-item uk-text-default" uk-scroll v-on:click="this.$store.commit('CHANGE_Lang')">{{this.$store.getters.Lang}}</a>
                        </li-->
                    </ul>
                </div>
            </div>
            <!-- Language -->
            <div v-if="this.$store.getters.Loaded || this.$store.getters.GetBlock.multilang" class="uk-flex uk-container-right uk-position-top-right uk-position-fixed uk-margin-xlarge-right uk-margin-xlarge-right uk-margin-top ">
                <a class="uk-icon-button uk-margin" uk-icon="icon:  world; ration:3" v-on:click="this.$store.commit('CHANGE_Lang')"></a>
            </div>
        </nav>
    
    </div>
    
</div>

<div v-if="this.$store.getters.Loaded" class="uk-flex uk-container-right uk-position-bottom-right uk-position-fixed uk-margin-right uk-container-small uk-position-z-index">
        <a class="uk-icon-button uk-margin uk-button-primary uk-button-smal" href="" uk-scroll="" uk-icon="icon: arrow-up"></a>
    </div>
</template>

<script>
import api from '@/api';


export default {
  name: 'NavBar',  
  data(){    
    return{        
             
    }    
  },
  beforeMount(){
    window.scrollTo(0, 0)
  },
  methods:{
    logout(){
        var $this=this
        this.$store.commit('SET_Loaded',false)
       api.post('api/auth/logout').then(res=>{
        if (res.status==200){
            localStorage.removeItem('access_token')
            this.$router.push({name:'home'})
            $this.$store.commit('SET_Loaded',true)
            $this.$store.commit('SET_ACCESS_DIR',false)
        }
       }) 
    }
  }
  }
</script>



